import React from 'react';
import { FavoriteButtonContainer } from '../../favorites/favorite_button_container';

interface CSPEmptyStateProps {
  heading: string;
  feedPrompt: string
}

export function CSPEmptyState(props: CSPEmptyStateProps) {
  return (
    <aside className="align-center width-80 mobile-width-100 mlr-auto">
      <div className="scaling-padding-8 bg-offwhite bg--lighten">
        <FavoriteButtonContainer
          displayStyle="banner"
          header={props.heading}
          subtext={props.feedPrompt}
        />
      </div>
    </aside>
  );
}
